/** Recruiter endpoints — jobs, profile, team, archive, candidate search. */
import client from './client';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const recruiterAPI = {
  createProfile: async (data) => (await client.post('/recruiters/profile', data)).data,
  getProfile: async () => (await client.get('/recruiters/profile')).data,
  updateProfile: async (data) => (await client.put('/recruiters/profile', data)).data,
  createJob: async (data) => (await client.post('/jobs', data)).data,
  getJobs: async (params = {}) => {
    const q = new URLSearchParams();
    if (params.skip) q.append('skip', String(params.skip));
    if (params.limit) q.append('limit', String(params.limit));
    if (params.status) q.append('status', params.status);
    if (params.job_type) q.append('job_type', params.job_type);
    if (params.sort_by) q.append('sort_by', params.sort_by);
    if (params.sort_order) q.append('sort_order', params.sort_order);
    return (await client.get(`/jobs?${q.toString()}`)).data;
  },
  getJob: async (id) => (await client.get(`/jobs/${id}`)).data,
  updateJob: async (id, data, opts = {}) => (await client.put(`/jobs/${id}${opts.reopenRejected ? '?reopen_rejected=true' : ''}`, data)).data,
  previewReopen: async (id, newThreshold) => (await client.get(`/jobs/${id}/reopen-preview`, { params: { new_threshold: newThreshold } })).data,
  triggerMatching: async (id) => (await client.post(`/jobs/${id}/match`)).data,
  getJobMatches: async (id) => (await client.get(`/jobs/${id}/matches`)).data,
  getAnalytics: async () => (await client.get('/recruiters/analytics')).data,
  getTeam: async () => (await client.get('/recruiters/team')).data,
  inviteTeamMember: async (email, name, position) => (await client.post('/recruiters/team/invite', { email, name, position })).data,
  removeTeamMember: async (id) => (await client.delete(`/recruiters/team/${id}`)).data,
  searchCandidateByEmail: async (email) => (await client.get(`/recruiter/search-candidate?email=${encodeURIComponent(email)}`)).data,
  getPostingStatus: async () => (await client.get('/recruiters/posting-status')).data,
  archiveJob: async (id) => (await client.post(`/jobs/${id}/archive`)).data,
  restoreJob: async (id) => (await client.post(`/jobs/${id}/restore`)).data,
  deleteJob: async (id) => (await client.delete(`/jobs/${id}`)).data,
  getArchivedJobs: async (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') q.append(k, String(v));
    });
    return (await client.get(`/jobs/archive?${q.toString()}`)).data;
  },
};

export default recruiterAPI;
export { API_URL };
